<div class="contact_address">

 <div class="infos">
    <div class="contact">
      <h4>Contact</h4>
      <div class="contact_content" >
        <p>
          <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon> {{clubSelected?.contactPerson}}
        </p>
        <p>
          <fa-icon [icon]="getFaIcon('faPhone')" appChangeColorTheme attribute="color"></fa-icon> {{clubSelected?.phoneNumber}}
        </p>
        <p>
          <fa-icon [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color"></fa-icon> {{clubSelected?.mail}}
        </p>
        <p>
          <fa-icon [icon]="getFaIcon('faSms')" appChangeColorTheme attribute="color"></fa-icon> {{clubSelected?.smsPhoneNumber || 'NC'}}
        </p>
      </div>
    </div>

    <div class="address">
      <h4>Adresse</h4>
      <p>{{clubSelected?.addressNumber}}<span *ngIf="club?.box">{{clubSelected?.box}}</span> {{clubSelected?.address}} </p>
      <p>{{clubSelected?.postalCode}} - {{clubSelected?.city}}</p>
    </div>

    <div class="legalNotices">
      <button class="add_user" type="button" (click)="openDialogLegalNotices()" appChangeColorTheme attribute="bgc">
        <fa-icon [icon]="getFaIcon('faInfoCircle')"></fa-icon>
        <span>Mentions légales</span>
      </button>
    </div>

    <div class="cgv">
      <div class="upload_cgv" *ngIf="(!pdf?.length || updatePdf) && !isLoadingCGV" >
        <span appChangeColorTheme attribute="bgc" >{{pdf?.length ?'Modifier' :'Ajouter'}} les CGV</span>
        <input type="file" name="CGV" (change)="uploadCGV($event)">
        <fa-icon [icon]="getFaIcon('faUndo')" class="faUndo" (click)="updateCGV()" *ngIf="pdf?.length" appChangeColorTheme attribute="color"></fa-icon>
      </div>

      <div class="download_cgv" *ngIf="pdf?.length && !updatePdf && !isLoadingCGV" appChangeColorTheme attribute="bgc" rgba="0.1">
        <a [href]="pdfTrust" download >
          <fa-icon [icon]="getFaIcon('faFilePdf')" appChangeColorTheme attribute="color"></fa-icon>
          Télécharger les CGV du club
        </a>
        <fa-icon class="faEdit" [icon]="getFaIcon('faEdit')" (click)="updateCGV()" appChangeColorTheme attribute="color"></fa-icon>
      </div>

      <mat-spinner *ngIf="isLoadingCGV" [diameter]="50"></mat-spinner>

    </div>
 </div>

 <div class="logo">
  <h4>Logo du club</h4>

  <div class="img" *ngIf="clubSelected?.logo || (!clubSelected?.logo && logoUpdate)" >
    <img [src]="logo" alt="logo_club" >
  </div>

  <div class="input_logo" appChangeColorTheme attribute="bgc">
      {{club?.logo ? 'Ajouter le logo du club' : 'Modifier le logo du club'}}
      <input type="file" name="logo" (change)="uploadLogo($event)">
  </div>

  <section class="federationSection">
    <h4>Fédération(s)</h4>
    <ul class="federationList">
      <li *ngFor="let federation of clubSelected.federation">
       {{federation.label}} <fa-icon *ngIf="federation.description" [icon]="getFaIcon('faInfoCircle')" [matTooltip]="federation.description" appChangeColorTheme attribute="color"></fa-icon>
      </li>
    </ul>
  </section>

 </div>

</div>
